import React, { useEffect, useMemo } from 'react'
import * as classes from './FourthScreen.module.scss'
import { deleteHtmlTag } from '../../../../utils/deleteHtmlTag'
import { startAnimationScroll } from '../../../../utils/animations'
import splitTitleV2 from '../../../../utils/splitTitleV2'
import { useDataFourthScreenByHy } from './useDataFourthScreenByHy'
import { useDataFourthScreenByEn } from './useDataFourthScreenByEn'
import { useDataFifthScreenByHy } from './useDataFifthScreenByHy'
import { useDataFifthScreenByEn } from './useDataFifthScreenByEn'

function FourthScreen({ lang }) {
    const dataFourthByHy = useDataFourthScreenByHy()
    const dataFourthByEn = useDataFourthScreenByEn()

    const dataFourth = lang === 'hy' ? dataFourthByHy : dataFourthByEn

    const dataFifthByHy = useDataFifthScreenByHy()
    const dataFifthByEn = useDataFifthScreenByEn()
    const dataFifth = lang === 'hy' ? dataFifthByHy : dataFifthByEn

    const formatTotalNum = (value) => deleteHtmlTag(value, 'all').trim().replace(/\+\s*$/, '')

    const fifthTotalNum = useMemo(() => formatTotalNum(dataFifth.totalNum.value), [])
    const fifthTotalText = useMemo(() => deleteHtmlTag(dataFifth.totalText.value, 'p'), [])

    const fourthTotalNum = useMemo(() => formatTotalNum(dataFourth.totalNum.value), [])
    const fourthTotalText = useMemo(() => deleteHtmlTag(dataFourth.totalText.value, 'p'), [])

    const fifthItems = useMemo(
        () => [
            {
                count: deleteHtmlTag(dataFifth.itemTitle_1.value, 'p'),
                title: deleteHtmlTag(dataFifth.itemText_1.value, 'p')
            },

            {
                count: deleteHtmlTag(dataFifth.itemTitle_2.value, 'p'),
                title: deleteHtmlTag(dataFifth.itemText_2.value, 'p')
            }
        ],
        []
    )

    const fourthItems = useMemo(
        () => [
            {
                count: deleteHtmlTag(dataFourth.itemTitle_1.value, 'p'),
                title: deleteHtmlTag(dataFourth.itemText_1.value, 'p')
            },

            {
                count: deleteHtmlTag(dataFourth.itemTitle_2.value, 'p'),
                title: deleteHtmlTag(dataFourth.itemText_2.value, 'p')
            },

            {
                count: deleteHtmlTag(dataFourth.itemTitle_3.value, 'p'),
                title: deleteHtmlTag(dataFourth.itemText_3.value, 'p')
            },

            {
                count: deleteHtmlTag(dataFourth.itemTitle_4.value, 'p'),
                title: deleteHtmlTag(dataFourth.itemText_4.value, 'p')
            }
        ],
        []
    )

    const classAnimationTitle = 'anime-title-numbers-main'
    const classAnimationText = 'anime-text-numbers-main'
    const classAnimationLine = 'anime-line-numbers-main'

    useEffect(() => {
        splitTitleV2(classAnimationTitle)

        const observer = startAnimationScroll([
            { type: 'title', className: classAnimationTitle },
            { type: 'textFull', className: classAnimationText },
            { type: 'lineVertical', className: classAnimationLine }
        ])

        return () => {
            if (observer) {
                observer.disconnect()
            }
        }
    }, [])

    return (
        <section className={classes.Section}>
            <div>
                <div className={classes.Inner}>
                    <div className={classes.Row}>
                        <div className={classes.Total}>
                            <p className={`${classes.TotalNum} ${classAnimationTitle}`}>
                                {fifthTotalNum}
                                <b>+</b>
                            </p>

                            <p className={`${classes.TotalText} ${classAnimationText}`} dangerouslySetInnerHTML={{ __html: fifthTotalText }} />
                        </div>

                        <div className={classes.Details}>
                            {fifthItems.map((item, index) => (
                                <div className={classes.DetailsItem} key={index}>
                                    <span
                                        className={`${classes.DetailsItemNum} ${classAnimationTitle}`}
                                        dangerouslySetInnerHTML={{ __html: item.count }}
                                        data-html='Y'
                                    />

                                    <p className={`${classes.DetailsItemText} ${classAnimationText}`} dangerouslySetInnerHTML={{ __html: item.title }} />
                                </div>
                            ))}

                            <span className={`${classes.Line} ${classAnimationLine}`} />
                        </div>
                    </div>

                    <div className={classes.Row}>
                        <div className={classes.Total}>
                            <p className={`${classes.TotalNum} ${classAnimationTitle}`}>
                                {fourthTotalNum}
                                <b>+</b>
                            </p>

                            <p className={`${classes.TotalText} ${classAnimationText}`} dangerouslySetInnerHTML={{ __html: fourthTotalText }} />
                        </div>

                        <div className={classes.Details}>
                            {fourthItems.map((item, index) => (
                                <div className={classes.DetailsItem} key={index}>
                                    <span
                                        className={`${classes.DetailsItemNum} ${classAnimationTitle}`}
                                        dangerouslySetInnerHTML={{ __html: item.count }}
                                        data-html='Y'
                                    />

                                    <p className={`${classes.DetailsItemText} ${classAnimationText}`} dangerouslySetInnerHTML={{ __html: item.title }} />
                                </div>
                            ))}

                            <span className={`${classes.Line} ${classAnimationLine}`} />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default FourthScreen
